import React from "react";
import { Box, Typography } from "@material-ui/core";

import {
  TripCategory,
  Dealness,
  Prediction,
} from "redmond";
import {
  PriceWatchCard,
  PricePredictionCard,
  PredictionForecast,
  getPricesWithComma,
  Icon,
  IconName,
} from "halifax";
import {
  FORECASTED_HIGHEST,
  FORECASTED_LOWEST,
  getLowestPriceInFiat,
  getLowestPriceInRewards,
  getPricePredictionCurrentPriceSubtitle,
  getPriceWatchCopy,
  PRICE_PREDICTION,
  PRICE_PREDICTION_CURRENT_PRICE_TITLE,
  WATCH_TRIP,
  WATCHING,
  WatchState,
  SLASH_SEPARATOR,
} from "../../constants";
import PricePredictionBar from "./PricePredictionBar";
import { IDeleteWatch } from "../../actions/actions";
import {
  getForecastedPriceDisplayText,
  isForecastedPriceSensible,
} from "../../utils/helpers";

interface IMobilePricePredictionFullProps {
  prediction: Prediction | null;
  tripCategory: TripCategory;
  isWatching: boolean;
  hasUnsupportedPredictionFilters: boolean;
  deleteWatch: () => IDeleteWatch;
  rewardsKey: string | undefined;
  onOpenPriceDropProtection: () => void;
  onOpenWatchModal: () => void;
  onClose: () => void;
  canRedeemRewards: boolean;
}

export const MobilePricePredictionFull = ({
  prediction,
  tripCategory,
  isWatching,
  hasUnsupportedPredictionFilters,
  deleteWatch,
  rewardsKey,
  onOpenPriceDropProtection,
  onOpenWatchModal,
  onClose,
  canRedeemRewards,
}: IMobilePricePredictionFullProps) => {
  const getForecastedPrice = (prediction: Prediction) => {
    const displayText = getForecastedPriceDisplayText(prediction);
    if (displayText) {
      return (
        <Typography className="content" variant="h4">
          {displayText}
          {/* TODO: display RewardText once the backend is ready */}
        </Typography>
      );
    }
    return "";
  };

  return (
    <Box className="mobile-price-prediction-full">
      {prediction && (
        <>
          <PricePredictionBar
            prediction={prediction}
            onOpenPrediction={onClose}
            onOpenPriceDrop={onOpenPriceDropProtection}
          />
          <PricePredictionCard
            className="current-price"
            title={PRICE_PREDICTION_CURRENT_PRICE_TITLE}
            subtitle={getPricePredictionCurrentPriceSubtitle(tripCategory)}
            content={
              <Typography variant="h5">
                <span className="current-price-lowestprice">
                  <b>
                    {getPricesWithComma(
                      getLowestPriceInFiat(prediction?.lowestPrice)
                    )}
                  </b>
                </span>
                {canRedeemRewards &&
                  getLowestPriceInRewards(
                    prediction?.lowestPrice,
                    rewardsKey,
                    SLASH_SEPARATOR
                  )}
              </Typography>
            }
          />
        </>
      )}

      {prediction &&
        getForecastedPrice(prediction) &&
        isForecastedPriceSensible(prediction) && (
          <PricePredictionCard
            className="forecasted-price"
            title={
              prediction.dealness === Dealness.Wait
                ? FORECASTED_LOWEST
                : FORECASTED_HIGHEST
            }
            icon={
              <Icon
                className={
                  prediction.dealness === Dealness.Wait
                    ? "forecasted-lowest-icon"
                    : "forecasted-highest-icon"
                }
                name={
                  prediction.dealness === Dealness.Wait
                    ? IconName.DecreaseReviewed
                    : IconName.IncreasedReviewed
                }
              />
            }
            content={getForecastedPrice(prediction)}
            subtitle={getPricePredictionCurrentPriceSubtitle(tripCategory)}
            isForecastedPrice
          />
        )}

      <PriceWatchCard
        className="price-prediction-watch price-prediction-card"
        title={getPriceWatchCopy(
          isWatching ? WatchState.Watched : WatchState.NotWatching,
          hasUnsupportedPredictionFilters,
          prediction?.predictionCopy
        )}
        buttonCopy={isWatching ? WATCHING : WATCH_TRIP}
        onClick={() => (isWatching ? deleteWatch() : onOpenWatchModal())}
        isWatching={isWatching}
      />
      {prediction && prediction.predictionCopy && (
        <Box className="prediction-forecast-section">
          <Typography variant="h4" className="prediction-forecast-header">
            {PRICE_PREDICTION}
          </Typography>
          <PredictionForecast
            className="b2b"
            intervals={prediction.predictionCopy.intervals}
          />
        </Box>
      )}
    </Box>
  );
};

export const MobilePricePredictionFullTitle = () => (
  <Box className="mobile-price-prediction-full-title">
    <Typography variant={"h3"}>{PRICE_PREDICTION}</Typography>
  </Box>
);
